export enum EmailUnsubscribes {
    UNSUBSCRIBE_FROM_ALL_PORTAL_EMAILS = "unsubscribeFromAllPortalEmails",
    UNSUBSCRIBE_FROM_PS_PORTAL_ORDER = "UnsubscribeFromPSPortalOrder",
}
